export default "__VITE_ASSET__jj5iSxy4__"